import React from 'react';
export const Footer = () => {
  return <footer className="py-8 text-center bg-[#000a11] w-full text-[#EEEEEE] text-sm" data-id="element-17">
      <p data-id="element-18">© 2025 Zenora. All Rights Reserved.</p>
      <p className="mt-2 mx-5 text-[calc(theme(fontSize.sm)-4px)]" data-id="element-19">
        THIS IS AN ADVERTISEMENT AND NOT AN ACTUAL NEWS ARTICLE, BLOG, OR
        CONSUMER PROTECTION UPDATE
      </p>
    </footer>;
};